var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgInbox = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 8H10.6663L9.33301 10H6.66634L5.33301 8H1.33301",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63301 3.40675L1.33301 8.00008V12.0001C1.33301 12.3537 1.47348 12.6928 1.72353 12.9429C1.97358 13.1929 2.31272 13.3334 2.66634 13.3334H13.333C13.6866 13.3334 14.0258 13.1929 14.2758 12.9429C14.5259 12.6928 14.6663 12.3537 14.6663 12.0001V8.00008L12.3663 3.40675C12.256 3.18461 12.0858 2.99766 11.875 2.86693C11.6642 2.73621 11.4211 2.66688 11.173 2.66675H4.82634C4.57828 2.66688 4.33518 2.73621 4.12437 2.86693C3.91356 2.99766 3.74339 3.18461 3.63301 3.40675V3.40675Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInbox, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/inbox.735cc2ee.svg";
export { ForwardRef as ReactComponent };